import { useQuery } from '@tanstack/react-query';
import api from '../lib/api';
import type { ApiResponse } from '../types/task';

export interface MeResponse {
  sub: string;
  email?: string;
  given_name?: string;
  family_name?: string;
  role?: string;
  groups?: string[];
  authType?: 'jwt' | 'apiKey';
}

/**
 * Fetches the authenticated user's profile + Cognito group memberships.
 * Used for RBAC gates (isAdmin) and display.
 */
export function useMe() {
  const query = useQuery({
    queryKey: ['me'],
    queryFn: async () => {
      const res = await api.get<ApiResponse<MeResponse>>('/me');
      return res.data!;
    },
    staleTime: 1000 * 60 * 5,
    retry: false,
  });

  const groups = query.data?.groups ?? [];
  const isAdmin = groups.includes('Admins');
  // Admins implicitly have board-member access for finance-sensitive views.
  const isBoardMember = isAdmin || groups.includes('BoardMembers');

  return {
    me: query.data,
    groups,
    isAdmin,
    isBoardMember,
    isLoading: query.isLoading,
  };
}
